import { useEffect, useState } from "react";
import { Pencil, Check, X, PlusCircle } from "lucide-react";

// One free-text note from the agency about the Brand's Journey numbers
export const JourneyNote = ({ note, readOnly, onSave }) => {
  const body = (note?.body || "").trim();
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(body);
  useEffect(() => { setDraft(body); }, [body]);

  if (readOnly && !body) return null;

  if (editing) {
    return (
      <div className="mt-3 rounded-xl border border-lime-300/30 bg-lime-300/[0.05] p-4" data-testid="journey-note-edit">
        <textarea
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          autoFocus
          rows={4}
          placeholder="Write a note for the client about these numbers: what drove the jumps, what to watch next."
          className="w-full bg-slate-950/50 text-white text-[13px] leading-relaxed rounded-lg border border-white/10 focus:border-lime-300/50 outline-none px-3 py-2 placeholder:text-slate-500 resize-y"
          data-testid="journey-note-textarea"
        />
        <div className="mt-2 flex justify-end gap-2">
          <button type="button" onClick={() => { setDraft(body); setEditing(false); }} className="inline-flex items-center gap-1 px-3 py-1.5 rounded-lg text-slate-300 hover:text-white text-xs" data-testid="journey-note-cancel">
            <X className="w-3.5 h-3.5" /> Cancel
          </button>
          <button type="button" onClick={async () => { await onSave(draft.trim()); setEditing(false); }} className="inline-flex items-center gap-1 px-3 py-1.5 rounded-lg bg-lime-300 hover:bg-lime-200 text-slate-900 text-xs font-bold" data-testid="journey-note-save">
            <Check className="w-3.5 h-3.5" /> Save note
          </button>
        </div>
      </div>
    );
  }

  if (!body) {
    return (
      <button
        type="button"
        onClick={() => setEditing(true)}
        className="mt-3 w-full flex items-center gap-2 rounded-xl border border-dashed border-lime-300/30 hover:border-lime-300/60 px-4 py-3 text-left transition-colors"
        data-testid="journey-note-add"
      >
        <PlusCircle className="w-4 h-4 text-lime-300 shrink-0" />
        <span className="text-slate-300 text-[12px]">Add a note for the client about these numbers</span>
      </button>
    );
  }

  return (
    <div className="mt-3 flex items-start gap-3 rounded-xl border border-lime-300/25 bg-lime-300/[0.05] px-4 py-3" data-testid="journey-note">
      <p className="flex-1 min-w-0 text-white text-[13px] leading-relaxed whitespace-pre-wrap" data-testid="journey-note-text">{body}</p>
      {!readOnly && (
        <button type="button" onClick={() => setEditing(true)} className="shrink-0 text-slate-400 hover:text-lime-300" aria-label="Edit note" data-testid="journey-note-edit-btn">
          <Pencil className="w-4 h-4" />
        </button>
      )}
    </div>
  );
};

export default JourneyNote;
